if (!customElements.get('compare-table')) {
  class CompareTable extends HTMLElement {
    constructor() {
      super();

      this.onMouseDown = this.onMouseDown.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
      this.onMouseUp = this.onMouseUp.bind(this);
    }

    connectedCallback() {
      if (!this) return;

      this.isDown = false;
      this.startX = 0;
      this.startScroll = 0;

      this.addEventListener('mousedown', this.onMouseDown);
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
    }

    onMouseDown(e) {
      this.isDown = true;
      this.startX = e.pageX;
      this.startScroll = this.scrollLeft;
      this.classList.add('dragging');
    }

    onMouseMove(e) {
      if (!this.isDown) return;

      e.preventDefault();
      this.scrollLeft = this.startScroll - (e.pageX - this.startX);
    }

    onMouseUp() {
      this.isDown = false;
      this.classList.remove('dragging');
    }
  }

  customElements.define('compare-table', CompareTable);
}
